module.exports = __webpack_public_path__ + "static/media/nowayround-regular-webfont.a77335b6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/nowayround-regular-webfont.ttf
// module id = 570
// module chunks = 0